import { Formik, Form } from "formik";
import React, { useState } from "react";
import { Grid, Button, Typography } from "@mui/material";
import TextField from "../../../components/FormikFields/TextField";
import Modal from "../../../components/Modal";
import LoadingButton from "../../../components/Buttons/LoadingButton";
import { useDispatch } from "react-redux";
import { createIntegration } from "../../../redux/actions/repositoryActions";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";

const schema = Yup.object().shape({
  name: Yup.string().required(),
  redirectUri: Yup.string().required()
});

const IntegrationModal = ({ open, onClose }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [isSaving, setSaving] = useState(false);

  const handleSave = (values, setSubmitting, resetForm) => {
    const onSuccess = () => {
      resetForm();
      setSaving(false);
      setSubmitting(false);
      onClose();
    };
    const onError = () => {
      setSaving(false);
      setSubmitting(false);
    };
    dispatch(createIntegration(values, onSuccess, onError));
  };

  return (
    <Formik
      initialValues={{ name: "", redirectUri: "" }}
      validationSchema={schema}
      enableReinitialize
      onSubmit={(values, { setSubmitting, resetForm }) => {
        setSaving(true);
        handleSave(values, setSubmitting, resetForm);
      }}
    >
      {({ submitForm, resetForm, errors }) => (
        <Modal
          showCloseIcon
          dialogTitle={
            <Typography variant="h4" color="textPrimary">
              {t("manageRepository.addIntegration.modalTitle")}
            </Typography>
          }
          open={open}
          onClose={() => {
            resetForm();
            onClose();
            setSaving(false);
          }}
          dialogContent={
            <Form>
              <Grid container>
                <Grid item xs={12}>
                  <TextField
                    label={t("manageRepository.addIntegration.nameLabel")}
                    name="name"
                    error={errors.name}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label={t(
                      "manageRepository.addIntegration.redirectUriLabel"
                    )}
                    name="redirectUri"
                    error={errors.redirectUri}
                    fullWidth
                  />
                </Grid>
              </Grid>
            </Form>
          }
          dialogActions={
            <>
              <Button
                color="primary"
                onClick={() => {
                  resetForm();
                  onClose();
                  setSaving(false);
                }}
              >
                {t("cancelBtn")}
              </Button>
              <LoadingButton
                pending={isSaving}
                color="primary"
                variant="contained"
                onClick={submitForm}
                disabled={isSaving}
              >
                {t("saveBtn")}
              </LoadingButton>
            </>
          }
          maxWidth="sm"
          fullWidth
          scrollable
        />
      )}
    </Formik>
  );
};

export default IntegrationModal;
